// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"47":"d710c83da021f13d","469":"086a598c7ddcc68a","484":"de9cdbb05401a9d6","820":"cb3791468ab71d75","829":"b1dfc70dcd386e12","892":"b1c4b682e49462f2"}[chunkId] + ".js";
};